import React, { useState } from 'react'
import * as Mui from '@mui/material'
import SendIcon from '@mui/icons-material/Send'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import SyncLockRoundedIcon from '@mui/icons-material/SyncLockRounded'
import { useNavigate } from 'react-router-dom'

import { CommonBtn, NumberPad } from '../../components'
import RUCHIVEDIKA_LOGO from '../../assets/ruchi-vedika-compressed.png'
import { loginIntoApp } from '../../services'
import { useAppDispatch } from '../../redux-store/hooks'
import { logIntoApp } from '../../redux-store/reducers'

const PinLoginScreen: React.FC = () => {
  const navigate = useNavigate()
  const dispatcher = useAppDispatch()
  const [employeeId, setEmployeeId] = useState('')
  const [pin, setPin] = useState('')
  const [activeField, setActiveField] = useState<'employeeId' | 'pin'>(
    'employeeId'
  )
  const theme = Mui.useTheme()
  const primaryColor = theme.palette.primary.main
  const empInputBorder =
    activeField === 'employeeId' ? `8px solid ${primaryColor}` : ``
  const pinInputBorder =
    activeField === 'pin' ? `8px solid ${primaryColor}` : ``

  const handleInputChange = (newInput: string) => {
    if (activeField === 'employeeId') {
      setEmployeeId(newInput)
    } else {
      setPin(newInput)
    }
  }

  const handleLogin = async () => {
    if (employeeId !== '' && pin !== ' ') {
      const response = await loginIntoApp(employeeId, pin)
      if (response && response.isSuccess) {
        dispatcher(
          logIntoApp({
            token: response?.data?.token,
            userId: response?.data?.userId,
          })
        )
        navigate('/', { replace: true })
      }
    } else {
      console.error('Invalid Employee Id or PIN')
    }
  }

  const [isPin, setIsPin] = useState(false)

  const handleToggle = () => {
    setIsPin((prev) => !prev)
  }

  return (
    <Mui.Stack
      height={'100vh'}
      flexDirection={'row'}
      sx={{
        backgroundImage: `linear-gradient(to right, ${theme.palette.secondary.main} 50%, ${theme.palette.primary.light} 100%)`,

        // backgroundImage: `linear-gradient(to right, ${theme.palette.secondary.main} 60%, ${theme.palette.primary.light} 100%)`,
        backgroundSize: '100% 100%',
        backgroundPosition: '0% 0%',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Mui.Grid container>
        <Mui.Grid
          item
          xs={'auto'}
          md={8}
          lg={8}
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' },
          }}
        >
          <Mui.Typography variant="caption" fontWeight={'bold'} color="primary">
            Version: Express POS v1.2.5
          </Mui.Typography>
          <Mui.Stack
            height={'100vh'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <img
              src={RUCHIVEDIKA_LOGO}
              alt="Product"
              style={{ maxWidth: 300, objectFit: 'fill', borderRadius: 30 }}
            />
          </Mui.Stack>
        </Mui.Grid>

        <Mui.Grid item xs={12} md={4} lg={4}>
          <Mui.Stack
            height={'100vh'}
            padding={16}
            justifyContent={'center'}
            alignItems={'center'}
            gap={4}
          >
            <Mui.Box
              mb={'-25px'}
              display={'flex'}
              flexDirection={'column'}
              justifyContent={'center'}
              alignItems={'center'}
              width={300}
              gap={0.5}
            >
              <Mui.Typography
                variant="h5"
                fontWeight={'bold'}
                color="secondary"
              >
                Choose Login Mode
              </Mui.Typography>
              <Mui.Box
                onClick={handleToggle}
                sx={{
                  width: 70,
                  height: 30,
                  borderRadius: '20px',
                  backgroundColor: 'color3.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: isPin ? 'flex-end' : 'flex-start',
                  px: '1px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
              >
                <Mui.IconButton
                  disableRipple
                  size="medium"
                  sx={{
                    color: 'CommonWhite.main',
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    transition: 'transform 0.3s ease',
                    transform: isPin ? 'rotate(360deg)' : 'rotate(0deg)',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  {isPin ? (
                    <AccountCircleIcon fontSize="medium" />
                  ) : (
                    <SyncLockRoundedIcon fontSize="medium" />
                  )}
                </Mui.IconButton>
              </Mui.Box>
            </Mui.Box>

            <Mui.Stack
              flexDirection={'column'}
              sx={{
                width: isPin ? 259 : 300,
                transition: 'width 0.3s ease',
              }}
              spacing={1}
            >
              <div
                style={{
                  borderRight: empInputBorder,
                  width: '100%',
                  padding: 5,
                  transition: 'all 0.3s ease',
                }}
              >
                <Mui.TextField
                  label={isPin ? 'Employee Id' : 'Employee Mail'}
                  variant="outlined"
                  type={`${isPin} ? "number" : "text"`}
                  value={employeeId}
                  color="error"
                  onFocus={() => setActiveField('employeeId')}
                  onChange={(e) => setEmployeeId(e.target.value)}
                  fullWidth
                />
              </div>
              <div
                style={{
                  borderRight: pinInputBorder,
                  width: '100%',
                  padding: 5,
                  transition: 'all 0.3s ease',
                }}
              >
                <Mui.TextField
                  label={isPin ? 'PIN' : 'Passord'}
                  type="password"
                  variant="outlined"
                  color="error"
                  value={pin}
                  onFocus={() => setActiveField('pin')}
                  onChange={(e) => setPin(e.target.value)}
                  inputProps={{
                    pattern: '[0-9]*',
                    maxLength: 10,
                  }}
                  fullWidth
                />
              </div>

              <Mui.Collapse in={isPin} timeout={300} unmountOnExit>
                <NumberPad
                  onChange={handleInputChange}
                  value={activeField === 'employeeId' ? employeeId : pin}
                />
              </Mui.Collapse>
              <CommonBtn
                variant="contained"
                color="secondary"
                onClick={handleLogin}
                endIcon={<SendIcon />}
                //style={{ height: 40 }}
              >
                Login
              </CommonBtn>
              {/* <Mui.Button
                variant="contained"
                color="success"
                onClick={handleLogin}
                endIcon={<SendIcon />}
                style={{ height: 40 }}
              >
                Login
              </Mui.Button> */}
            </Mui.Stack>
          </Mui.Stack>
        </Mui.Grid>
      </Mui.Grid>
    </Mui.Stack>
  )
}

export { PinLoginScreen as LoginScreen }
